export interface StripeCredentials {
  secretKey: string
  environment: 'test' | 'live'
}

export interface StripeWebhookConfig {
  endpointUrl: string
  endpointSecret: string
  events: string[]
}

export interface StripeConnection {
  isConnected: boolean
  accountId?: string
  accountName?: string
  environment: 'test' | 'live'
  webhookEndpoint?: string
  connectedAt?: string
}

export interface StripeValidationResult {
  valid: boolean
  error?: string
  accountInfo?: {
    id: string
    name: string
    country: string
    currency: string
  }
}

export type StripeConnectionStep =
  | 'credentials'
  | 'webhook'
  | 'verification'
  | 'complete'

export const STRIPE_WEBHOOK_EVENTS = [
  'payment_intent.succeeded',
  'payment_intent.payment_failed',
  'customer.created',
  'customer.updated',
  'customer.deleted',
  'invoice.created',
  'invoice.payment_succeeded',
  'invoice.payment_failed',
  'subscription.created',
  'subscription.updated',
  'subscription.deleted',
  'charge.succeeded',
  'charge.failed',
] as const

export type StripeWebhookEvent = (typeof STRIPE_WEBHOOK_EVENTS)[number]
